import { useCampaignSendSize } from 'modules/campaigns/lib/hooks';
import { CampaignState } from 'modules/domains/campaign';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';

import { useScheduleCampaignMutation } from '../../../lib/hooks/useScheduleCampaignMutation';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { useGenerateCampaignAlerts } from '../../hooks';
import { ScheduleEligibilityFormState } from '../../types';
import {
  getErrorSchedulingCampaignMessage,
  getSuccessfullyScheduledCampaignMessage,
} from '../../utils';
import { getEligibilitySchedulePayload } from '../DisplayEligibilityCampaignModal/DisplayEligibilityCampaignModal.utils';

export const useScheduleEligibilityCampaign = () => {
  const { closeModal } = useModalContext();
  const {
    campaign,
    refetch: refetchCampaign,
    estimatedSendSizeData,
    expectedSendSizeData,
  } = useCampaignContext();
  const { isLoading, mutate, error } = useScheduleCampaignMutation();
  const { generateCampaignAlerts } = useGenerateCampaignAlerts();
  const { name, campaignState, id, campaignAlertsEnabled } = campaign;

  const { sendSize } = useCampaignSendSize({ estimatedSendSizeData, expectedSendSizeData });

  const dispatch = useDispatch();

  const isScheduledCampaign = campaignState === CampaignState.Scheduled;

  const scheduleEligibilityCampaign = (values: ScheduleEligibilityFormState) => {
    const onSuccess = () => {
      const message = getSuccessfullyScheduledCampaignMessage(name, isScheduledCampaign);
      dispatch(addPositiveToast(message));
      generateCampaignAlerts({ campaignAlertsEnabled, id });
      closeModal(ModalType.DisplayEligibilityCampaign);
      refetchCampaign();
    };

    const onError = (e: unknown) => {
      const errorMessage = getErrorSchedulingCampaignMessage(e);
      dispatch(addNegativeToastWithErrorId(errorMessage, 'scheduleEligibilityCampaign', e));
    };

    const payload = getEligibilitySchedulePayload(values, campaign, sendSize as number);

    closeModal(ModalType.ConfirmDisplayEligibilityCampaign);

    mutate(payload, {
      onSuccess,
      onError,
    });
  };

  return { isLoading, error, scheduleEligibilityCampaign };
};
